import { AfterContentInit, Component, ContentChildren, QueryList, Input, Output, EventEmitter } from '@angular/core';

import { PuiTabComponent } from './tab.component';

@Component({
  selector: 'pui-tabs',
  templateUrl: 'tabs.component.html'
})
export class PuiTabsComponent implements AfterContentInit {
  @Input() attachedPortlet = false;
  @ContentChildren(PuiTabComponent) tabs: QueryList<PuiTabComponent>;
  @Output() select: EventEmitter<PuiTabComponent> = new EventEmitter<PuiTabComponent>();
  constructor() { }

  ngAfterContentInit() {
    // get all active tabs
    const activeTabs = this.tabs.filter((tab) => tab.active);
    // if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }

    // this.init.emit({tabs: this.tabs.toArray()});
  }

  selectTab(item: PuiTabComponent) {
    // deactivate all tabs
    this.tabs.forEach(tab => tab.active = false);
    // activate the tab the user has clicked on.
    item.active = true;
    this.select.emit(item);
  }
}
